export default function PrivacyPolicyPage() {
  return (
    <div className="py-20 md:py-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl sm:text-5xl font-bold text-primary mb-8">Privacy Policy</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm text-muted-foreground">Last Updated: January 2026</p>
          
          <section className="mt-8">
            <h2 className="text-2xl font-bold text-primary mb-4">1. Introduction</h2>
            <p className="leading-relaxed">
              Get Logo Trademarked ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website getlogotrademarked.com and use our trademark, copyright, and intellectual property services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">2. Information We Collect</h2>
            <h3 className="text-xl font-semibold text-primary mb-3">Personal Information</h3>
            <p className="leading-relaxed mb-4">
              We collect information that you voluntarily provide to us when you register for our services, express interest in obtaining information about us or our products and services, or otherwise contact us. The personal information we collect may include:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Name and contact information (email address, phone number, mailing address)</li>
              <li>Business information (company name, business type, industry)</li>
              <li>Trademark and intellectual property details</li>
              <li>Payment information (processed securely through third-party payment processors)</li>
              <li>Communications with our customer service team</li>
            </ul>
            
            <h3 className="text-xl font-semibold text-primary mb-3">Automatically Collected Information</h3>
            <p className="leading-relaxed mb-4">
              When you visit our website, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and cookies installed on your device. We use this information to analyze trends, administer the site, track users' movements, and gather demographic information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">3. How We Use Your Information</h2>
            <p className="leading-relaxed mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide, operate, and maintain our trademark and intellectual property services</li>
              <li>Process your trademark registration, copyright filing, or other service requests</li>
              <li>Communicate with you about your applications, case status, and service updates</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Send you administrative information, such as changes to our terms, conditions, and policies</li>
              <li>Process payments and prevent fraudulent transactions</li>
              <li>Comply with legal obligations and USPTO filing requirements</li>
              <li>Improve our website and services based on your feedback</li>
              <li>Send marketing communications (with your consent where required)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">4. Information Sharing and Disclosure</h2>
            <p className="leading-relaxed mb-4">We may share your information with:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Government Agencies:</strong> USPTO, U.S. Copyright Office, and other relevant government bodies as required for trademark and intellectual property filing</li>
              <li><strong>Service Providers:</strong> Third-party vendors who perform services on our behalf (payment processing, email delivery, hosting services)</li>
              <li><strong>Legal Compliance:</strong> When required by law, court order, or government regulation</li>
              <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
            </ul>
            <p className="leading-relaxed mt-4">
              We do not sell, rent, or trade your personal information to third parties for marketing purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">5. Data Security</h2>
            <p className="leading-relaxed">
              We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your information, we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">6. Your Privacy Rights</h2>
            <p className="leading-relaxed mb-4">Depending on your location, you may have certain rights regarding your personal information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access and receive a copy of your personal information</li>
              <li>Correct or update inaccurate information</li>
              <li>Request deletion of your information (subject to legal retention requirements)</li>
              <li>Object to or restrict processing of your information</li>
              <li>Withdraw consent for marketing communications</li>
            </ul>
            <p className="leading-relaxed mt-4">
              To exercise these rights, please contact us at Info@getlogotrademarked.com.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">7. Cookies and Tracking Technologies</h2>
            <p className="leading-relaxed">
              We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">8. Third-Party Links</h2>
            <p className="leading-relaxed">
              Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">9. Children's Privacy</h2>
            <p className="leading-relaxed">
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children under 18. If you become aware that a child has provided us with personal information, please contact us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">10. Changes to This Privacy Policy</h2>
            <p className="leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary mb-4">11. Contact Us</h2>
            <p className="leading-relaxed mb-4">
              If you have questions or concerns about this Privacy Policy, please contact us:
            </p>
            <div className="bg-background-surface p-6 rounded-sm">
              <p className="font-semibold text-primary">Get Logo Trademarked</p>
              <p>468 N Camden Dr</p>
              <p>Beverly Hills, CA 90210</p>
              <p>Email: Info@getlogotrademarked.com</p>
              <p>Phone: +1 (123) 123-4567</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
